module.exports = __webpack_public_path__ + "img/gjsfw.0ea2fe0.png";